<template>
  <v-card outlined>
    <v-card-title class="subtitle-1 font-weight-bold grey lighten-4 py-3">
      <v-icon color="primary" class="mr-2">summarize</v-icon>
      Resumen de conciliación al {{ formatUtils.formatDateString(dateTo) }}
    </v-card-title>
    <v-simple-table dense class="resumen">
      <tbody>
        <tr>
          <td>Saldo según extracto bancario</td>
          <td class="text-right">{{ formatUtils.formatMoney(r.saldo_extracto) }}</td>
        </tr>
        <tr v-if="r.partidas_acreditar">
          <td class="grey--text text--darken-2">(+) Depósitos no acreditados</td>
          <td class="text-right">{{ formatUtils.formatMoney(r.partidas_acreditar) }}</td>
        </tr>
        <tr v-if="r.partidas_debitar">
          <td class="grey--text text--darken-2">(−) Cheques / pagos no debitados</td>
          <td class="text-right error--text">{{ formatUtils.formatMoney(r.partidas_debitar) }}</td>
        </tr>
        <tr v-if="Math.abs(r.syscore_sin_clasificar) >= 0.01">
          <td class="orange--text text--darken-3">(±) Movimientos Syscore sin conciliar</td>
          <td class="text-right orange--text text--darken-3">{{ formatUtils.formatMoney(r.syscore_sin_clasificar) }}</td>
        </tr>
        <tr class="total">
          <td>Saldo bancario ajustado</td>
          <td class="text-right">{{ formatUtils.formatMoney(r.saldo_bancario_ajustado) }}</td>
        </tr>
        <tr class="spacer"><td colspan="2"></td></tr>
        <tr>
          <td>Saldo según Syscore</td>
          <td class="text-right">{{ formatUtils.formatMoney(r.saldo_syscore) }}</td>
        </tr>
        <tr>
          <td class="grey--text text--darken-2">(+) Créditos del banco no registrados</td>
          <td class="text-right">{{ formatUtils.formatMoney(r.banco_creditos_no_registrados) }}</td>
        </tr>
        <tr>
          <td class="grey--text text--darken-2">(−) Gastos e impuestos bancarios no registrados</td>
          <td class="text-right error--text">{{ formatUtils.formatMoney(r.banco_debitos_no_registrados) }}</td>
        </tr>
        <tr class="total">
          <td>Saldo Syscore ajustado</td>
          <td class="text-right">{{ formatUtils.formatMoney(r.saldo_syscore_ajustado) }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <div class="pa-3 d-flex align-center" :class="coincide ? 'green lighten-5' : 'red lighten-5'">
      <v-icon :color="coincide ? 'success' : 'error'" class="mr-2">{{ coincide ? "check_circle" : "error" }}</v-icon>
      <span v-if="coincide">Saldos ajustados coinciden · diferencia <b>{{ formatUtils.formatMoney(0) }}</b></span>
      <span v-else>Diferencia no explicada <b>{{ formatUtils.formatMoney(r.diferencia) }}</b></span>
    </div>
    <div v-if="blockers.length" class="pa-3 caption grey--text text--darken-2">
      Para guardar la conciliación:
      <ul>
        <li v-for="(b, i) in blockers" :key="i">{{ b }}</li>
      </ul>
    </div>
  </v-card>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  props: {
    summary: Object,
    dateTo: String,
    blockers: { type: Array, default: () => [] },
  },
  data() {
    return { formatUtils };
  },
  computed: {
    r() {
      return this.summary.resumen;
    },
    coincide() {
      return Math.abs(this.r.diferencia) < 0.01;
    },
  },
};
</script>

<style scoped>
.resumen td {
  height: 38px !important;
}
.resumen .total td {
  font-weight: bold;
  border-top: 1px solid #bdbdbd;
}
.resumen .spacer td {
  height: 12px !important;
  border: none !important;
}
</style>
